module.exports = __webpack_public_path__ + "static/media/je.7e5795cf.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/je.svg
// module id = 2123
// module chunks = 0